module.exports = __webpack_public_path__ + "static/icon4-2cefd423392c220381a2fb2d03f5b45b.png";